import PlanDisabled from "./PlanDisabled";

export default PlanDisabled;